export default (client) => ({
	listChannels: () => client.get(`/notification-channels/`),
	update: ({ nodeId, fields }) => client.put(`/workflow-nodes/${nodeId}/notification/`, fields),
	getChannelParamOptions: ({ channelId, source, term, param_key, page, retrievalId }) =>
		client.post(`notification-channels/${channelId}/options/`, { source, term, param_key, page, retrievalId }, { $fullData: true }),
});
